import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Checkbox, Form, Input } from "antd";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useStores } from "../../../../../../../store/root.js";
import { ColumnToolTipHeader } from "../../../../../../table/column-tooltip-header.js";
function useRuleGroupColumns(t) {
    const { rcbAuthenticationStore } = useStores();
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    return [
        {
            title: t("Name"),
            dataIndex: "id",
            render: (_, record, index)=>{
                return /*#__PURE__*/ _createElement(Form.Item, {
                    ...record,
                    shouldUpdate: (prev, next)=>{
                        const previousNames = useConcatRuleGroupNames(prev.ruleGroups);
                        const nextNames = useConcatRuleGroupNames(next.ruleGroups);
                        const should = prev.ruleGroups[record.name] !== next.ruleGroups[record.name] || previousNames !== nextNames;
                        return should;
                    },
                    key: `id${index}`,
                    name: [
                        record.name,
                        "id"
                    ],
                    rules: [
                        ({ getFieldValue })=>({
                                validator: (_rule, value)=>{
                                    const ruleGroups = getFieldValue("ruleGroups");
                                    const duplicate = ruleGroups.find((field, fieldIndex)=>{
                                        return fieldIndex !== index && field.id?.toLowerCase() === value?.toLowerCase();
                                    });
                                    if (duplicate) {
                                        return Promise.reject(new Error(t(`Please enter a unique name for group id entry number ${index + 1}`)));
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            }),
                        {
                            required: true,
                            message: t(`Please provide an id for entry number ${index + 1}`)
                        }
                    ],
                    noStyle: true
                }, /*#__PURE__*/ _jsx(Input, {
                    style: {
                        maxWidth: "100%"
                    },
                    disabled: !hasCreatorRole
                }));
            }
        },
        {
            title: /*#__PURE__*/ _jsx(ColumnToolTipHeader, {
                columnName: t("Must be resolved"),
                tooltipTitle: t("If this option is enabled, it means that at least one rule from this group must be resolved for the content blocker (or connected service) to be recommended in the scanner. Other groups may or may not be resolved.")
            }),
            dataIndex: "mustGroupBeResolved",
            render: (_, record, index)=>/*#__PURE__*/ _createElement(Form.Item, {
                    ...record,
                    key: `mustGroupBeResolved${index}`,
                    name: [
                        record.name,
                        "mustGroupBeResolved"
                    ],
                    valuePropName: "checked",
                    noStyle: true
                }, /*#__PURE__*/ _jsx(Checkbox, {
                    disabled: !hasCreatorRole,
                    children: t("Group must be resolved")
                })),
            width: "15rem"
        },
        {
            title: /*#__PURE__*/ _jsx(ColumnToolTipHeader, {
                columnName: t("Must all rules be resolved"),
                tooltipTitle: t("If this option is active, all rules in this group must be resolved to recommend the content blocker (or associated service) in the scanner. Otherwise, one matching rule is required for the group to be considered fulfilled.")
            }),
            dataIndex: "mustAllRulesBeResolved",
            render: (_, record, index)=>/*#__PURE__*/ _createElement(Form.Item, {
                    ...record,
                    key: `mustAllRulesBeResolved${index}`,
                    name: [
                        record.name,
                        "mustAllRulesBeResolved"
                    ],
                    valuePropName: "checked",
                    noStyle: true
                }, /*#__PURE__*/ _jsx(Checkbox, {
                    disabled: !hasCreatorRole,
                    children: t("All rules must be resolved")
                })),
            width: "15rem"
        }
    ];
}
function useRuleGroupDisplayColumns(t) {
    return [
        {
            title: t("Id"),
            dataIndex: "id"
        },
        {
            title: t("Resolve Group"),
            dataIndex: "mustGroupBeResolved",
            render: (_)=>{
                return Boolean(_) === true ? t("Yes") : t("No");
            }
        },
        {
            title: t("Resolve All Rules"),
            dataIndex: "mustAllRulesBeResolved",
            render: (_)=>{
                return Boolean(_) === true ? t("Yes") : t("No");
            }
        }
    ];
}
function useConcatRuleGroupNames(ruleGroups, excludeIndex = []) {
    return ruleGroups?.map((field, fieldIndex)=>excludeIndex.includes(fieldIndex) ? undefined : field.id).filter(Boolean).join("");
}
export { useRuleGroupColumns, useRuleGroupDisplayColumns };
